export enum FundingDateTypeEnum {
    LAST_6_MONTHS = 'LAST_6_MONTHS',
    LAST_1_YEAR = 'LAST_1_YEAR',
    CUSTOM = 'CUSTOM',
}
